export function LogoCotacao() {
  const blocos = [
    {
      cor: '#FFC300',
      d: 'M13.64 6.82h34.11a6.82 6.82 0 0 1 6.82 6.82v47.75a6.82 6.82 0 0 1-6.82 6.82H13.64a6.82 6.82 0 0 1-6.82-6.82V13.64a6.82 6.82 0 0 1 6.82-6.82z',
    },
    {
      cor: '#E80C0C',
      d: 'M88.69 6.82h34.11a6.82 6.82 0 0 1 6.82 6.82v20.47a6.82 6.82 0 0 1-6.82 6.82H88.69a6.82 6.82 0 0 1-6.82-6.82V13.64a6.82 6.82 0 0 1 6.82-6.82z',
    },
    {
      cor: '#1A9929',
      d: 'M88.69 68.22h34.11a6.82 6.82 0 0 1 6.82 6.82v47.76a6.82 6.82 0 0 1-6.82 6.82H88.69a6.82 6.82 0 0 1-6.82-6.82V75.04a6.82 6.82 0 0 1 6.82-6.82z',
    },
    {
      cor: '#3a63ff',
      d: 'M13.64 95.51h34.11a6.82 6.82 0 0 1 6.82 6.82v20.47a6.82 6.82 0 0 1-6.82 6.82H13.64a6.82 6.82 0 0 1-6.82-6.82v-20.46a6.82 6.82 0 0 1 6.82-6.82z',
    },
  ];
  return (
    <svg viewBox="0 0 136.44 136.44" aria-hidden className="logo-cotacao">
      {blocos.map((b) => (
        <path
          key={b.cor}
          d={b.d}
          fill={b.cor}
          stroke={b.cor}
          strokeWidth={13.64}
          strokeLinejoin="round"
        />
      ))}
    </svg>
  );
}
